export default __webpack_public_path__ + "locales/en/ChangeUserStatusDialog.json?hash=f13ac6193bacc6599f4e91d478677300";